import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IFollowUpTask } from "../../utils/types/models";

export default createEntityReducer<IFollowUpTask>(null, Endpoint.TasksList);
